import _classCallCheck from "/home/elixx/src/eternal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/elixx/src/eternal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/elixx/src/eternal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/elixx/src/eternal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/elixx/src/eternal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { Uniform, Vector2 } from "three";
import { BlendFunction } from "./blending/BlendFunction.js";
import { Effect, EffectAttribute } from "./Effect.js";
var fragment = "varying vec2 vUvR;\r\nvarying vec2 vUvB;\r\n\r\nvoid mainImage(const in vec4 inputColor, const in vec2 uv, out vec4 outputColor) {\r\n\r\n\tvec4 color = inputColor;\r\n\r\n\tcolor.r = texture2D(inputBuffer, vUvR).r;\r\n\tcolor.b = texture2D(inputBuffer, vUvB).b;\r\n\r\n\toutputColor = color;\r\n\r\n}\r\n";
var vertex = "uniform vec2 offset;\r\n\r\nvarying vec2 vUvR;\r\nvarying vec2 vUvB;\r\n\r\nvoid mainSupport() {\r\n\r\n\tvUvR = uv + offset;\r\n\tvUvB = uv - offset;\r\n\r\n}\r\n";
/**
 * A chromatic aberration effect.
 */

export var ChromaticAberrationEffect =
/*#__PURE__*/
function (_Effect) {
  _inherits(ChromaticAberrationEffect, _Effect);

  /**
   * Constructs a new chromatic aberration effect.
   *
   * @param {Object} [options] - The options.
   * @param {BlendFunction} [options.blendFunction=BlendFunction.NORMAL] - The blend function of this effect.
   * @param {Vector2} [options.offset] - The color offset.
   */
  function ChromaticAberrationEffect() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, ChromaticAberrationEffect);

    var settings = Object.assign({
      blendFunction: BlendFunction.NORMAL,
      offset: new Vector2(0.001, 0.0005)
    }, options);
    return _possibleConstructorReturn(this, _getPrototypeOf(ChromaticAberrationEffect).call(this, "ChromaticAberrationEffect", fragment, {
      attributes: EffectAttribute.CONVOLUTION,
      blendFunction: settings.blendFunction,
      uniforms: new Map([["offset", new Uniform(settings.offset)]]),
      vertexShader: vertex
    }));
  }
  /**
   * The color offset.
   *
   * @type {Vector2}
   */


  _createClass(ChromaticAberrationEffect, [{
    key: "offset",
    get: function get() {
      return this.uniforms.get("offset").value;
    }
    /**
     * @type {Vector2}
     */
    ,
    set: function set(value) {
      this.uniforms.get("offset").value = value;
    }
  }]);

  return ChromaticAberrationEffect;
}(Effect);